import React from "react";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";

// Shared participant-auth page frame. Standardises navbar/footer separation, top
// offset below the sticky navbar, form column width and mobile behaviour across
// Sign in and OTP. Content follows naturally — no min-h/viewport spacers.
export function AuthShell({ children, testid, maxWidth = "max-w-[500px]" }) {
  return (
    <div className="App" data-testid={testid}>
      <Navbar />
      <main className="flex items-start justify-center px-5 sm:px-6 pt-20 sm:pt-24 pb-16 sm:pb-20">
        <div className={`w-full ${maxWidth} fade-up`}>{children}</div>
      </main>
      <Footer />
    </div>
  );
}
